import { action } from "typesafe-actions";
import { FeatureFlagsActionTypes, FeatureFlagsState } from "./types";

export const fetchFlags = () => action(FeatureFlagsActionTypes.FETCH_FLAGS);
export const setFlags = (flags: FeatureFlagsState) => action(FeatureFlagsActionTypes.SET_FLAGS, flags);
export const setIsLoading = (isLoading: boolean) => action(FeatureFlagsActionTypes.SET_IS_LOADING, isLoading);
